<template>
  <div class="department-list">
    <el-checkbox-group v-model="checkedList" :disabled="isDisabled">
      <div v-for="(item, index) in deptsData" :key="item.id" :data-index="index" :class="deptCardContainerStyle(item)"
        @click="handleServiceClick($event, index)" :style="cardStyle(index)">
        <div class="department-card-left">
          <div class="department-card-img">
            <img :src="deptIcon(item.id)" alt="暫無圖片" />
          </div>
          <div class="department-card-text">
            <div :class="deptTextStyle(item.id, 'dept-text')">{{ item.label }}</div>

            <div :class="deptDescClass(item.id)">{{ item.desc }}</div>
            <div :class="deptDescClass(item.id)">{{ item.oversea }}</div>


          </div>
        </div>


        <el-checkbox :label="item.id"><br /></el-checkbox>


        <el-button v-show="item.moredetail" class='more-btn' type="warning" @click.stop @click="onMoreDetail(item)"> {{
          item.moredetail }} </el-button>
      </div>
    </el-checkbox-group>
  </div>
</template>

<script>
const cardColorList = ["#d9ebe7", "#dfeaf5", "#faedd9"];
import { getLocale } from "@/i18n.js";
import { queryPageData } from "@/api/contact.js";



export default {
  props: {
    isDisabled: Boolean,
    deptsData: Array,
    isMacauAddress: Boolean,
    checked: Boolean,
  },
  watch: {
    deptsData: function () {
      if (this.checked) {
        this.selectAll();
      }
    }
  },
  data() {
    return {
      checkedList: [],
    };
  },
  mounted() { },
  methods: {

    toVnode(data) {
      let el = data[0];
      let config = data[1];
      let content = data[2];

      if (Array.isArray(content)) {
        content = content.map(x => this.toVnode(x))
      }

      return this.$createElement(el, config, content);
    },

    async getPageData(dept) {
      const lang = getLocale();

      try {
        const { data } = await queryPageData(dept, lang);
        if (data && data.status == "ok") {
          return data.page;
        }
      } catch (error) {
        console.log(error);
        return undefined;
      }

    },


    async onMoreDetail(item) {
      //console.log(item)
      //console.log(this.$parent)

      const pageData = await this.getPageData(item.id)
    
      //console.log('!!!', pageData)
      if(!pageData) { return}

      const messageContent = this.toVnode(pageData)
      this.$msgbox({
        title: item.label,
        message: messageContent,
        showClose: false,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: this.$t('I_KNOW_IT'),
        confirmButtonClass: 'detail-confirm-btn',
        customClass: 'my-custom-class',
        modalClass: 'my-modal-class',

      });


    },
    handleServiceClick(event, index) {
      event.preventDefault();
      if (this.isDisabled) { return; }
      const dept = this.deptsData[index];
      const selectId = dept.id;
      this.checkedList = this.checkedList.includes(selectId)
        ? this.checkedList.filter((item) => item !== selectId)
        : [...this.checkedList, selectId];
      if (this.checked) {
        this.$emit('removeAlert', this.checkedList.length < this.deptsData.length);
      }
    },


    deptTextStyle(id, classname) {
      const longClassDepts = ["IHM"]
      if (longClassDepts.includes(id)) {
        return classname + "-long"
      }
      return classname
    },


    deptIcon(id) {
      const fileName = id.toLowerCase() + '_icon';
      try {
        return require(`@/assets/${fileName}.png`);
      } catch (e) {
        try {
          return require(`@/assets/${fileName}.svg`);
        } catch (e) {
          return require("@/assets/default_icon.png");
        }
      }
    },
    cardStyle(index) {
      return {
        "background-color": cardColorList[index % cardColorList.length],
      };
    },

    deptDescClass(dept) {
      return dept !== "SAFP" ? "dept-desc" : "dept-desc2";
    },

    reset() {
      this.checkedList = this.checked ? this.deptsData.map(x => x.id) : [];
    },

    selectAll() {
      this.checkedList = this.deptsData.map(x => x.id);
    },

    deptCardContainerStyle(item) {
      const locale = getLocale();
      if (locale != 'zh' && (item.desc || item.oversea)) {
        return { 'department-card': true, 'department-card-long': true, 'selected-department-card': this.checkedList.includes(item.id) }
      }

      return { 'department-card': true, 'selected-department-card': this.checkedList.includes(item.id) }
    }
  },
};
</script>

<style lang="scss">
.detail-confirm-btn {
  margin-top: 50px;
  width: 100%;
  border-radius: 15px;

}

.el-message-box .el-message-box__title {
  color: teal;
  /* Set the desired title text color */
  font-size: 25px;
}

.my-modal-class {
  background-color: balck;
}

.my-custom-class {
  background-color: #E0E0E0;
  color: white;
  width: 85%;
  max-width: 380px;
  border-radius: 20px;
}

.more-btn {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
  margin-top: -5px;
  padding: 3px 0px;
  border-radius: 10px;
  width: 100%;

}

.department-list {
  /*
  display: flex;
  flex-wrap: wrap;
  */
  width: 100%;

  .el-checkbox__inner {
    width: 26px;
    height: 26px;
  }

  .el-checkbox__inner::after {
    left: 9px;
    top: 5px;
    width: 6px;
    height: 10px;
  }
}

.department-card {
  padding: 15px;
  border-radius: 8px;
  height: 110px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  max-width: 320px;
  flex-wrap: wrap;
}

.department-card .el-checkbox {
  padding: 35px 0;
}

.department-card .el-checkbox__inner {
  border-radius: 50%;
  border: 1px solid #00785d;
}

.department-card-long {
  height: 220px;
}

.department-card-long .el-checkbox {
  padding: 80px 0;
}

.department-card-left {
  display: flex;
  justify-items: center;
  align-items: center;
}


.department-card-img img {
  width: 60px;
  max-height: 60px;
  margin: 0px;
  margin-right: 10px;
}

.department-card-text {
  padding: 0 1px;
  font-size: 18px;
  font-weight: 500;
  color: #232323;
  display: -webkit-box;
  max-width: 160px;
}

.dept-text {
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-inline-box;
  word-break: break-word;
}

.dept-text-long {
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-inline-box;
  word-break: break-word;
}


.dept-desc {
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-inline-box;
  font-size: 12px;
  color: #fc1d1d !important;
  font-weight: normal;
  word-break: break-word;
}

.dept-desc2 {
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-inline-box;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.8) !important;
  font-weight: normal;
  word-break: break-word;
}



.selected-department-card {
  border: 1px solid #00785d;
}
</style>